import React from 'react';

import DropDown from '../../common/DropDown';
import { BulkDisplayItems } from './BulkDisplayItems';
import { TFreelancerData, TJobItem, TSeries, TWorkerItem } from '../../../types';

export type TBulkActions = {
    isBulkExclusiveMode: boolean;
    isBulkMode: boolean;
    items: TJobItem[] | TWorkerItem[] | TFreelancerData[];
    totalNumberOfItemsInTable: number;
    defaultSelectionFromParam?: string;
    onBulkAction: (key: string, val: { value: string }) => void;
    user: any;
    selectedJobs: TJobItem[];
    selectedSeries?: TSeries;
    isAvailabilityRoute?: boolean;
    isUnallocatedFreelancersRoute?: boolean;
    isFreelancerRoute?: boolean;
    isMassBookingMode?: boolean;
    isSeriesMassBookingMode?: boolean;
    selectAllRows?: () => void;
    deselectAllRows?: () => void;
};

export function BulkActions({
    isBulkExclusiveMode,
    isBulkMode,
    items,
    totalNumberOfItemsInTable,
    defaultSelectionFromParam,
    onBulkAction,
    user,
    selectedJobs,
    selectedSeries,
    isAvailabilityRoute = false,
    isFreelancerRoute = false,
    isUnallocatedFreelancersRoute = false,
    isMassBookingMode = false,
    isSeriesMassBookingMode = false,
    selectAllRows,
    deselectAllRows,
}: TBulkActions) {
    const countOfSelected = isBulkExclusiveMode
        ? totalNumberOfItemsInTable - items.length
        : items.length;

    const options = [];

    if (
        user.agency.features.includes('dashboard_sms') &&
        user.permissions.includes('auth.sms_dashboard_allowed')
    ) {
        if (isAvailabilityRoute || isFreelancerRoute || isUnallocatedFreelancersRoute) {
            options.push({
                label: 'Send notification...',
                value: 'send_notification',
            },
            {
                label: 'Send SMS...',
                value: 'send_sms',
            });
        } else {
            options.push({
                label: 'Match workers',
                value: 'match_workers',
            });
            if (user.agency.features.includes('delegate_jobs')) {
                options.push({
                    label: 'Delegate jobs',
                    value: 'delegate_jobs',
                });
            }
        }
    }
    if (user.isAgent && (isAvailabilityRoute || isFreelancerRoute)) {
        options.push(
            {
                label: 'Add to list...',
                value: 'add_workers_to_list',
            },
        );
        if (isAvailabilityRoute) {
            options.push({
                label: 'Remove from list...',
                value: 'remove_workers_from_list',
            });
        }
    }

    if (isUnallocatedFreelancersRoute) {
        options.push({
            label: 'Claim workers...',
            value: 'claim_workers',
        });
    }

    const anyJobAndFreelancerShouldBeSelected =
        selectedJobs.length && items.length;

    if (anyJobAndFreelancerShouldBeSelected && isMassBookingMode) {
        options.push(
            {
                label: 'Book workers',
                value: 'book_workers',
            },
            {
                label: 'Invite workers',
                value: 'invite_workers',
            },
        );
    }

    const anySeriesAndFreelancerShouldBeSelected =
        selectedSeries && items.length;

    if (anySeriesAndFreelancerShouldBeSelected && isSeriesMassBookingMode) {
        options.push(
            {
                label: 'Book workers',
                value: 'book_workers_to_series',
            }
        );
    }

    return (
        isBulkMode && (
            <div className="bookings-bulk-actions">
                <div
                    className="bookings-bulk-actions__details"
                >
                    <BulkDisplayItems
                        countOfSelected={countOfSelected}
                        isFreelancersRoot={isFreelancerRoute || isAvailabilityRoute}
                    />
                    <div
                        className="action-string"
                        onClick={selectAllRows}
                        title={
                            `Select all ${isFreelancerRoute || isAvailabilityRoute ? 'workers' : 'jobs'} on this page`
                        }
                    >
                        Select all on the page
                    </div>
                    <div
                        className="action-string"
                        onClick={deselectAllRows}
                        title={
                            `Deselect all selected ${isFreelancerRoute || isAvailabilityRoute ? 'workers' : 'jobs'}`
                        }
                    >
                        Deselect all
                    </div>
                </div>
                {(items.length || isBulkExclusiveMode) && (
                    <DropDown
                        id="bulk-actions-menu"
                        filterKey="action"
                        defaultSelectionFromParam={defaultSelectionFromParam}
                        options={options}
                        defaultSelection={options[0]}
                        onFilterChange={onBulkAction}
                        renderSelected={() => (
                            <div className="dropdown-placeholder">
                                Bulk action...
                            </div>
                        )}
                        renderOption={(option: {
                            label: string;
                            value: string;
                        }) => <div>{option.label}</div>}
                    />
                )}
            </div>
        )
    );
}
